export default "__VITE_ASSET__CSx4cD6h__"